var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10526 11V7.84211H2V6.78947H3.05263V3.10526H3.57895V2.05263H4.10526V1.52632H4.63158V1H6.73684V1.52632H7.26316V2.05263H7.78947V3.10526H8.31579V6.78947H9.36842V7.84211H7.26316V11H6.21053V7.84211H5.15789V11H4.10526ZM6.21053 2.57895V2.05263H5.15789V2.57895H4.63158V3.63158H4.10526V6.78947H4.63158V6.26316H6.73684V6.78947H7.26316V3.63158H6.73684V2.57895H6.21053Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketS);
export default __webpack_public_path__ + "static/media/rocket-s.b6d82f6df07505be4ee293ed3759db44.svg";
export { ForwardRef as ReactComponent };